import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';
export default {
  state() {
    return {
      showTherapistPicture: null,
      showTherapistPsychologyOrganizationLink: null,

      showOtherAbilityFilter: null,
      showApproachFilter: null,
      showEducationDegreeFilter: null,
      showAgeRangeFilter: null,
      showGenderFilter: null,
      showTopicFilter: null,
    };
  },
  mutations,
  actions,
  getters,
};
